module.exports = __webpack_public_path__ + "static/img/29.e1fff17d.png";